import router from '@/router';
import { omitBy } from 'lodash';

const getQueryParams = () => {
  return router.currentRoute.value.query;
};

const updateQueryParams = (params) => {
  const stringifiedParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value ?? '')])
  );
  const { query, path } = router.currentRoute.value;
  const targetQuery = omitBy(
    { ...query, ...stringifiedParams },
    // removing empty string values
    (v) => v === ''
  );
  const isSamePath =
    path.replace(/\/$/, '') ===
    router.resolve(router.currentRoute).path.replace(/\/$/, '');
  const isSameQuery = JSON.stringify(query) === JSON.stringify(targetQuery);
  if (!isSamePath || !isSameQuery) router.replace({ query: targetQuery });
};

export const queryParamsHandler = {
  getQueryParams,
  updateQueryParams
};
